import { useSelector } from "react-redux"
import { getCurrentLocale } from "../../utils/common-util";

const useApplyLocale = (props) => {
  const locale = useSelector(store => (getCurrentLocale(store)??'').toLowerCase());
  return props.fallback ? (props[locale] ?? props[props.fallback]) : props[locale];
}

export default useApplyLocale;